/**
 * 募集要項から遷移した ?job= パラメータで、エントリーフォームの応募カテゴリーを初期選択する
 */
export default class Entry {
  constructor() {
    this.jobParam = this.getJobFromQuery();
    if (!this.jobParam) {
      return;
    }

    this.selectName = 'your-job';
    this.init();
  }

  getJobFromQuery() {
    const job = new URLSearchParams(window.location.search).get('job');
    return job ? job.trim() : '';
  }

  init() {
    this.applyJobSelect();

    document.addEventListener('wpcf7domready', () => {
      this.applyJobSelect();
    });
  }

  findJobSelect() {
    return document.querySelector(`select[name="${this.selectName}"]`);
  }

  applyJobSelect() {
    const select = this.findJobSelect();
    if (!select) {
      return;
    }

    const matchedOption = Array.from(select.options).find((option) => {
      const value = option.value.trim();
      const label = option.textContent.trim();
      return value === this.jobParam || label === this.jobParam;
    });

    if (!matchedOption) {
      return;
    }

    select.value = matchedOption.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
